// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2jIdb","content":"ManualTimeModal_content__l4b3I"};